import { render, staticRenderFns } from "./deleteOaWorkflow.vue?vue&type=template&id=c6fc1820"
import script from "./deleteOaWorkflow.vue?vue&type=script&lang=js"
export * from "./deleteOaWorkflow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports